import { axiosProviderNode } from "../../../../../../services/http/httpService.js"
import { services } from "../../services/loggerEndPoints.js"

async function getLogFilesInfo(params = {}) {
  try {
    const transactionNodeService =
      services.NODE_ENDPOINT_GET_LOGS_FILES_INFO_IMXLOGGER

    const res = await axiosProviderNode.get(transactionNodeService, params)
    return res?.data
  } catch (error) {
    throw error
  }
}
export default getLogFilesInfo
